import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/homeData';

interface VideoCardProps {
  video: VideoItem;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 hover:-translate-y-1"
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-[16/7]' : 'aspect-video'}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-950/80 text-white text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </div>
        {video.featured && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium">
            推荐
          </div>
        )}
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform group-hover:scale-100 scale-75">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className={`font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 ${size === 'large' ? 'text-base md:text-lg' : 'text-sm'}`}>
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-amber-400 text-xs"></i>
            {video.rating}
          </span>
          <span className="text-foreground-400">{video.date}</span>
        </div>
      </div>
    </Link>
  );
}